/* Tribe Alpha page sections: shared behaviour (reveal, photo reel, compare, scrub text, timeline, stacked cards, contact forms) */
(function(){
if(window.__taUI)return;window.__taUI=1;
function $$(s,r){return [].slice.call((r||document).querySelectorAll(s))}
function init(){
  var reduce=window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches;
  var ups=[];

  /* reveal on scroll */
  var secs=$$(".ta-page .ta-hero");
  function count(sec){$$("[data-count]",sec).forEach(function(el){
    var end=+el.dataset.count,t0=null;el.textContent="0";
    function step(t){if(!t0)t0=t;var p=Math.min(1,Math.max(0,(t-t0-1500)/900));
      el.textContent=Math.round(end*(1-Math.pow(1-p,3)));if(p<1)requestAnimationFrame(step)}
    requestAnimationFrame(step)})}
  function play(sec){sec.classList.remove("is-in");void sec.offsetWidth;sec.classList.add("is-in");count(sec)}
  if("IntersectionObserver" in window&&!reduce&&secs.length&&!(window.Shopify&&Shopify.designMode)){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){play(e.target);io.unobserve(e.target)}})},{threshold:.15});
    secs.forEach(function(s){s.classList.add("is-armed");io.observe(s)});
    setTimeout(function(){if(!secs[0].classList.contains("is-in")&&secs[0].getBoundingClientRect().top<innerHeight)play(secs[0])},1200);
  }

  /* photo slots with no image */
  $$("[data-ph]").forEach(function(b,i){if(b.querySelector("img,video"))return;
    var p=document.createElement("div");p.className="ph";p.style.setProperty("--gx",(20+i*12)+"%");p.textContent=b.dataset.ph||"Add a photo";b.appendChild(p)});

  /* photo reel: pinned, slides sideways on scroll */
  $$("[data-ta-reel]").forEach(function(reel){
    var track=reel.querySelector(".ta-reel__track"),cards=$$(".ta-reel__card",reel),bar=reel.querySelector(".ta-reel__bar i"),now=reel.querySelector(".ta-reel__now");
    var mq=matchMedia("(max-width:760px), (prefers-reduced-motion:reduce)");
    ups.push(function(){
      if(mq.matches){track.style.transform="";return}
      var r=reel.getBoundingClientRect(),vh=innerHeight,vw=document.documentElement.clientWidth;
      if(r.bottom<-vh||r.top>vh*2)return;
      var p=Math.min(1,Math.max(0,-r.top/(r.height-vh))),max=Math.max(0,track.scrollWidth-track.clientWidth);
      track.style.transform="translate3d("+(-p*max)+"px,0,0)";
      if(bar)bar.style.setProperty("--prog",p);
      if(now){var idx=Math.min(cards.length-1,Math.round(p*(cards.length-1)));now.textContent=("0"+(idx+1)).slice(-2)}
      cards.forEach(function(c){var b=c.querySelector(".ta-reel__img"),cr=c.getBoundingClientRect(),off=((cr.left+cr.width/2)-vw/2)/vw;
        b.style.setProperty("--par",(off*-10).toFixed(2));
        b.style.setProperty("--zoom",(1.04+Math.min(.1,Math.abs(off)*.12)).toFixed(3));
        b.style.setProperty("--clip",Math.min(18,Math.max(0,(Math.abs(off)-.35)*30)).toFixed(1)+"%")});
    });
  });

  /* before / after */
  $$("[data-ta-compare]").forEach(function(c){var r=c.querySelector("input[type=range]");
    r.addEventListener("input",function(){c.style.setProperty("--pos",r.value+"%")})});

  /* statement text lights up word by word */
  $$("[data-ta-scrub]").forEach(function(el){
    var gold=(el.dataset.gold||"").toLowerCase().split(",").map(function(s){return s.trim()}).filter(Boolean);
    var words=el.textContent.trim().split(/\s+/);el.textContent="";
    words.forEach(function(w,i){var s=document.createElement("span");s.className="w"+(gold.indexOf(w.toLowerCase())>-1?" g":"");s.textContent=w;el.appendChild(s);if(i<words.length-1)el.appendChild(document.createTextNode(" "))});
    var spans=$$(".w",el);
    if(reduce){spans.forEach(function(s){s.classList.add("on")});return}
    ups.push(function(){var r=el.getBoundingClientRect(),vh=innerHeight;
      var p=Math.min(1,Math.max(0,(vh*.85-r.top)/(r.height+vh*.45))),n=Math.round(p*spans.length);
      spans.forEach(function(s,i){s.classList.toggle("on",i<n)})});
  });

  /* timeline */
  $$("[data-ta-tl]").forEach(function(tl){var rail=tl.querySelector(".ta-tl__rail"),items=$$(".ta-tl__item",tl);
    ups.push(function(){var r=tl.getBoundingClientRect(),mid=innerHeight*.6;
      rail.style.setProperty("--tl",Math.min(1,Math.max(0,(mid-r.top)/r.height)).toFixed(3));
      items.forEach(function(it){it.classList.toggle("on",it.querySelector(".ta-tl__dot").getBoundingClientRect().top<mid)})})});

  /* stacked cards */
  $$("[data-ta-stack]").forEach(function(st){var cards=$$(".ta-stack__card",st),mq=matchMedia("(max-width:820px), (prefers-reduced-motion:reduce)");
    ups.push(function(){cards.forEach(function(c,i){var nx=cards[i+1];
      if(mq.matches||!nx){c.style.setProperty("--sc",1);return}
      var a=c.getBoundingClientRect(),b=nx.getBoundingClientRect(),p=Math.min(1,Math.max(0,1-(b.top-a.top)/a.height));
      c.style.setProperty("--sc",(1-p*.05).toFixed(3))})})});

  /* contact forms: show the thank-you after Shopify posts back */
  $$(".ta-msg").forEach(function(box){var f=box.querySelector("form"),done=box.querySelector(".ta-done"),k="taPosted";
    if(!f)return;f.addEventListener("submit",function(){try{sessionStorage.setItem(k,box.dataset.key)}catch(e){}});
    var w="";try{w=sessionStorage.getItem(k)||""}catch(e){}
    if(w===box.dataset.key&&/[?&]contact_posted=true/.test(location.search)){
      try{sessionStorage.removeItem(k)}catch(e){}
      f.hidden=true;done.hidden=false;setTimeout(function(){done.scrollIntoView({block:"center"})},60)}});

  var tick=false;function run(){tick=false;ups.forEach(function(u){u()})}
  function req(){if(!tick){tick=true;requestAnimationFrame(run)}}
  addEventListener("scroll",req,{passive:true});addEventListener("resize",req);run();
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init);else init();
})();
